import { Alert, Checkbox, Form, Space, Typography } from "antd";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import SpaceWrapper from "../../components/widgets/space-wrapper/SpaceWrapper";
import { CustomButton } from "../../components/widgets/custom-button/CustomButton";
import { useCustomToolStore } from "../../store/custom-tool-store";
import { useAlertStore } from "../../store/alert-store";
import { useExceptionHandler } from "../../hooks/useExceptionHandler";

function HighlightManager({ handleUpdateTool }) {
  const [enableHighlight, setEnableHighlight] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { details, updateCustomTool, isPublicSource, selectedHighlight } =
    useCustomToolStore();
  const { setAlertDetails } = useAlertStore();
  const handleException = useExceptionHandler();

  useEffect(() => {
    setEnableHighlight(details?.enable_highlight || false);
  }, []);

  const handleSubmit = () => {
    const body = {
      enable_highlight: enableHighlight,
    };
    setIsLoading(true);
    handleUpdateTool(body)
      .then(() => {
        const updatedDetails = { ...details };
        let selectedHighlightData = selectedHighlight;
        updatedDetails["enable_highlight"] = enableHighlight;
        if (details?.enable_highlight) {
          selectedHighlightData = null;
        }
        updateCustomTool({
          details: updatedDetails,
          selectedHighlight: selectedHighlightData,
        });
        setAlertDetails({
          type: "success",
          content: "Saved highlight settings successfully",
        });
      })
      .catch((err) => {
        setAlertDetails(handleException(err, "Failed to update"));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <SpaceWrapper>
      <div className="settings-body-pad-top">
        <Typography.Text strong className="pre-post-amble-title">
          Highlighting Support
        </Typography.Text>
      </div>
      <Alert
        message="Highlight Feature Availability"
        description="Highlight support is available only for LLM profiles that use LLMWhisperer as the Text Extraction service."
        type="info"
        showIcon
      />
      <Form layout="vertical" onFinish={handleSubmit}>
        <Form.Item>
          <Space>
            <Checkbox
              checked={enableHighlight}
              onChange={(e) => setEnableHighlight(e.target.checked)}
              disabled={isPublicSource}
            />
            <Typography.Text>Enable Highlighting</Typography.Text>
          </Space>
        </Form.Item>
        <Form.Item className="display-flex-right">
          <CustomButton
            type="primary"
            htmlType="submit"
            loading={isLoading}
            disabled={isPublicSource}
          >
            Save
          </CustomButton>
        </Form.Item>
      </Form>
    </SpaceWrapper>
  );
}

HighlightManager.propTypes = {
  handleUpdateTool: PropTypes.func.isRequired,
};

export { HighlightManager };
